import axios from "axios";

interface IAssetListParams {
  startDate: string,
  endDate: string,
  pageNo?: number;
  pageSize?: number;
}

export const getNonUsedVehicleList = (
  startDate: string,
  endDate: string,
  pageNo = 0,
  pageSize = 0
) => {

  let params: IAssetListParams = { startDate: startDate, endDate: endDate };

  if (pageNo !== 0) {
    params = { ...params, pageNo: pageNo };
  }

  if (pageSize !== 0) {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/gatereader/v3/vehicle/distancerecord/none", {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch(function (error) {
      throw error;
    });
};
